import mime from 'mime';

export const getMimeType = (filename: string) => {
  const splitByDot = filename.split('.');
  const ext = splitByDot[splitByDot.length - 1];

  return mime.getType(ext) || '*/*';
};

export const getFileDownloadDestinations = (filename: string, mimeType?: string) => {
  if (!mimeType) {
    mimeType = getMimeType(filename);
  }

  if (mimeType && mimeType !== '*/*') {
    const nameParts = filename.split('.');
    const noExtension = nameParts.length === 1;

    const mimeExtension = mime.getExtension(mimeType);
    const nameExtension = nameParts.pop();

    // Handles edge-cases for potential files with multiple extensions (for example as somefile.test.jpeg)
    const differentExtension = mimeExtension?.slice(0, 2) !== nameExtension?.slice(0, 2);

    if ((noExtension || differentExtension) && mimeExtension)
      filename = `${filename}.${mimeExtension}`;
  }

  const safeFileName = filename.split('/').join('-');
  const newNameParts = safeFileName.split('.');
  const newExtension = newNameParts[newNameParts.length - 1];

  const fileDestinations = [];
  let readMe;
  fileDestinations.push(safeFileName);
  if (newExtension === 'xml') {
    const basicName = newNameParts[0];
    fileDestinations.push(`${basicName}.html`);
    readMe = `Please Note: The content of these files is identical, although one may lack compatibility with mobile devices.`;
  }
  return { fileDestinations, safeFileName, newNameParts, readMe, mimeType };
};
